import React from 'react';
import { Table, TableRow, TableHeaderCell } from 'semantic-ui-react';

export default function FertilizerPrintWorksheetProductsTableRow(): React.ReactElement {
    return (
        <Table.Header>
            <TableRow>
                <TableHeaderCell>Chemical</TableHeaderCell>
                <TableHeaderCell>Rate</TableHeaderCell>
                <TableHeaderCell>Product total</TableHeaderCell>
                <TableHeaderCell>NPK</TableHeaderCell>
                <TableHeaderCell>SMgCa</TableHeaderCell>
                <TableHeaderCell>{}</TableHeaderCell>
                <TableHeaderCell>{}</TableHeaderCell>
                <TableHeaderCell>Order</TableHeaderCell>
                <TableHeaderCell>REP</TableHeaderCell>
                <TableHeaderCell>WHP</TableHeaderCell>
            </TableRow>
        </Table.Header>
    );
}
